module.exports = __webpack_public_path__ + "img/gs.42fc32da.jpg";